<template>
    <!-- <v-spacer></v-spacer> -->   
  <div>
    <app-header></app-header>
      <v-container grid-list-xl mt-5 v-on:click="hideBlock">
        <v-layout row wrap align-center justify-center>
          <v-flex xs12 sm6 md9 mt-5 mb-5>
            <div v-show="isLoading" align="center" class="mt-7">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
            <div v-show="!isLoading" class="mt-3">
              <div class="profile-body">
                 <v-layout row wrap>
                    <v-flex xs12>
                      <div id="postingTitle" class="font-30 font-weight-bold">{{ posting.postingTitle }}</div>
                    </v-flex>
                    <v-flex xs12>
                     <ul class="list-unstyled">
                        <li class="userDetail">
                          <div class="imgleft">
                            <v-avatar color="primary" class="pointer" size="40" @click="goUserData(userDetail.userName)">
                              <img v-show="userDetail.image != null" :src="userDetail.image" :alt="userDetail.userName">
                              <span v-show="userDetail.image == null" class="headline white--text">
                                {{ userDetail.userName != null ? userDetail.userName.trim().substring(0, 1).toLocaleUpperCase(): ''}}
                              </span>
                            </v-avatar>
                          </div>
                          <div class="right-side ml-2">
                            <a @click="goUserData(userDetail.userName)" class="fw-bold font-18">
                              {{ userDetail.nickName }}
                              <span>({{ userDetail.reputationScore }})</span>
                            </a>
                            <span class="ml-2 font-16 fw-500">
                              {{ $t('common.at') }} {{ dateFormat(posting.postingTime) }}
                            </span>
                          </div>
                        </li>
                        <li class="right mr-5">
                          <v-speed-dial v-model="fab" :left="true" direction="left" :open-on-hover="true" transition="slide-x-reverse-transition">
                            <v-btn class="share-icon" slot="activator" v-model="fab" color="primary" dark fab>
                              <v-icon>share</v-icon>
                              <v-icon>close</v-icon>
                            </v-btn>
                            <!--分享到linkedin-->
                            <v-btn color="primary" fab small dark>
                              <a href="javascript:window.open('http://www.linkedin.com/sharing/share-offsite/?title='+encodeURIComponent(document.getElementById('postingTitle').innerHTML)+'&url='+encodeURIComponent(document.location.href),'_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');void(0)">
                                <v-icon :title="$t('postingsel.linkedin')" color="white" type="social-twitter">mdi-linkedin</v-icon>
                              </a>
                            </v-btn>
                            <!--分享到facebook-->
                            <v-btn color="primary" fab small dark>
                              <a href="javascript:window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent(document.location.href)+'&t='+encodeURIComponent(document.title),'_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');void(0)">
                                <v-icon :title="$t('postingsel.facebook')" color="white" type="social-facebook">mdi-facebook</v-icon>
                              </a>
                            </v-btn>
                            <!--分享到google
                            <v-btn color="primary" fab small dark>
                              <a href="javascript:window.open('https://plus.google.com/share?url='+encodeURIComponent(document.getElementById('postingTitle').innerHTML)+' '+encodeURIComponent(document.location.href),'_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');void(0)">
                                <v-icon :title="$t('postingsel.google')" color="white" type="social-google">mdi-google</v-icon>
                              </a>
                            </v-btn>-->
                            <!--分享到twitter-->
                            <v-btn color="primary" fab small dark>
                              <a href="javascript:window.open('http://twitter.com/home?status='+encodeURIComponent(document.getElementById('postingTitle').innerHTML)+''+encodeURIComponent(document.location.href)+''+encodeURIComponent('@IOB_llc'),'_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');void(0)">
                                <v-icon :title="$t('postingsel.twitter')" color="white" type="social-twitter">mdi-twitter</v-icon>
                              </a>
                            </v-btn>
                          </v-speed-dial>
                        </li>
                    </ul> 
                  </v-flex>
                   <!--帖子内容-->
                  <v-flex xs12 mt-5>
                    <v-card-text id="posting-content" v-html="posting.postingContent" class="font-18"></v-card-text>
                  </v-flex>
                  <!-- category -->
                  <v-flex xs12 class="d-custom-flex">
                     <span class="font-14 mr-2 pa-2">{{ $t('postingsel.category') }}: </span>
                      <span><v-btn v-for="(market, index) in marketsList" v-if="market.marketId==posting.marketId" :key="index" small color="primary" @click="findByMarkets(market)">{{ market.name }}</v-btn>
                      </span>
                  </v-flex>
                  <!--标签-->
                  <v-flex xs12 class="d-custom-flex">
                    <span class="font-14 mr-2 pa-2" v-if="posting.tagList != null && posting.tagList.length > 0">{{ $t('postingsel.tags') }}: </span>
                    <span>
                        <v-btn outline small color="primary darken-1" @click="findtagposting(postingtag.tagName)" v-for="(postingtag, index) in posting.tagList" :key="index">
                        {{ postingtag.tagName }}
                        </v-btn>
                        <!-- 编辑帖子 -->
                        <v-btn small class="right" color="primary darken-1"v-show="this.$store.getters.user != null && posting.postingUserId == this.$store.getters.user.userId" @click="editPosting(posting)">
                          {{ $t('postingsel.edit') }}
                        </v-btn>
                    </span>
                  </v-flex>
                  <v-flex xs12 mt-2>
                      <div class="font-14 ml-2">
                        <v-icon size="20">schedule</v-icon>
                        <span>{{ dateFormat(posting.postingTime) }}&nbsp;{{ $t('common.by') }}</span>
                        <span class="Author">
                          <!--显示个人简介的方法@click="toggleuserinfo1"-->
                          <a id="userinfo" @click="goUserData(userDetail.userName)" class="font-16">
                            {{ userDetail.nickName }}
                            <span>({{ userDetail.reputationScore }})</span>
                          </a>
                        </span>
                      </div>
                      <!--  <Avatar v-bind:src="userDetail.image" size="small"/> -->
                      <!-- <div class="imgleft ml-3">
                         <v-avatar size="32">
                          <img :src="userDetail.image" class="img-responsive rounded-circle posting-img pointer" @click="goUserData(userDetail.userName)" />
                        </v-avatar>
                        <v-avatar color="primary" class="pointer" size="40" @click="goUserData(userDetail.userName)">
                          <img v-show="userDetail.image != null" :src="userDetail.image" :alt="userDetail.userName">
                          <span v-show="userDetail.image == null" class="headline white--text">
                            {{userDetail.userName != null ? userDetail.userName.trim().substring(0, 1).toLocaleUpperCase(): ''}}
                          </span>
                        </v-avatar>
                      </div> -->
                      <!-- <div class="right-side ml-2">
                        <span class="Author">
                          显示个人简介的方法@click="toggleuserinfo1"
                          <a id="userinfo" @click="goUserData(userDetail.userName)" class="font-18">
                            {{ userDetail.nickName }}
                            <span>({{ userDetail.reputationScore }})</span>
                          </a>
                        </span>
                      </div> -->
                  </v-flex>
                 </v-layout>
                    <div class="mt-30">
                      <!-- 原创或转载 -->
                      <span v-if="posting.isOriginal" class="primary--text ml-2 font-14">
                        {{ $t('postingsel.original') }}
                      </span>
                      <span v-if="!posting.isOriginal" class="pointer primary--text ml-2 font-14">
                        <a :href="posting.originalLink" target="_black">{{ $t('postingsel.source') }}</a>
                      </span>
                      <!-- 操作 -->
                      <span class="social-list clearfix right">
                        <ul class="list-inline d-inline-block">
                          <!-- Andy编辑帖子 -->
                          <li>
                            <a class="font-1x mr-3" v-if="this.user != null && this.user.userName == 'Andy'" @click="editPosting(posting)">{{ $t('postingsel.edit') }}</a>
                          </li>
                          <!-- $ -->
                          <li>
                            <v-icon small :title="$t('posting.bonus')">fas fa-dollar-sign</v-icon>
                            <span class="font-14">{{ posting.bonus != null ? posting.bonus.toFixed(2) : 0.0 }}</span>
                          </li>
                          <!-- up -->
                          <li v-show="posting.postingStatus == 0">
                            <v-icon small color="primary" @click="changesup" :title="$t('posting.upvote')">thumb_up_alt</v-icon>
                            <span class="font-14 ml-1"> {{ posting.postingGoodnums }}
                              <v-icon small class="fa-fort-down-icon" @click="getUpvoteUser">fas fa-sort-down</v-icon>
                            </span>
                            <v-icon small :title="$t('postingsel.tread')" @click="changesdown">thumb_down_alt</v-icon>
                            <span class="font-14 ml-1">
                              {{ posting.postingStepnums }}
                              <v-icon small class="fa-fort-down-icon" @click="getDownvoteUser">fas fa-sort-down</v-icon>
                            </span>
                          </li>
                          <!-- down -->
                          <li v-show="posting.postingStatus == 1">
                            <v-icon small @click="changesup" :title="$t('posting.upvote')">thumb_up_alt</v-icon>
                              <span class="font-14 ml-1">{{ posting.postingGoodnums }}
                                <v-icon small class="fa-fort-down-icon" @click="getUpvoteUser">fas fa-sort-down</v-icon>
                              </span>
                              <v-icon small color="primary" :title="$t('postingsel.tread')" @click="changesdown">thumb_down_alt</v-icon>
                              <span class="font-14 ml-1">
                                {{ posting.postingStepnums }}
                                <v-icon small class="fa-fort-down-icon" @click="getDownvoteUser">fas fa-sort-down</v-icon>
                              </span>
                          </li>
                          <li v-show="posting.postingStatus == -1">
                            <v-icon small @click="changesup" :title="$t('posting.upvote')">thumb_up_alt</v-icon>
                            <span class="font-14 ml-1">{{ posting.postingGoodnums }}
                              <v-icon small class="fa-fort-down-icon" @click="getUpvoteUser">fas fa-sort-down</v-icon>
                            </span>
                            <v-icon small @click="changesdown" :title="$t('postingsel.tread')">thumb_down_alt</v-icon>
                            <span class="font-14 ml-1">
                              {{ posting.postingStepnums }}
                              <v-icon small class="fa-fort-down-icon" @click="getDownvoteUser">fas fa-sort-down</v-icon>
                            </span>
                          </li>
                          <li>
                            <v-icon small :title="$t('posting.comment')" class="poin" @click="commentsshow">fa fa-comment</v-icon>
                            <span class="font-14 ml-1">{{ posting.postingCountComments }}</span>
                          </li>
                          <li>
                            <v-icon small @click="modalzf(posting)" :title="$t('posting.retweet')">fa fa-share</v-icon>
                            <span class="font-14 ml-1">{{ posting.postingCountForword }}</span>
                          </li>
                          <li v-show="posting.postingCollection == 0">
                            <v-icon small color="primary" :title="$t('posting.save')" @click="collectionPosting">fa fa-star</v-icon>
                          </li>
                          <li v-show="posting.postingCollection != 0">
                            <v-icon small :title="$t('posting.save')" @click="collectionPosting">fa fa-star</v-icon>
                          </li>
                        </ul>
                        <!-- - - - - - 点赞用户div- - - - - - - -->
                        <div id="upvoteUserDiv" v-show="isShowUpvoteUserDiv" class="dropdown">
                          <div v-for="user in upvoteUserList">
                            <div class="pointer font-14" @click="goUserData(user.userName)">+ {{ user.userName }}</div>
                          </div>
                          <div v-show="posting.postingGoodnums > 20">
                            <div @click="getUpvoteUser">……</div>
                          </div>
                        </div>
                        <!-- - - - - - 点踩用户div- - - - - - - -->
                        <div v-show="isShowDownvoteUserDiv" class="dropdown ml-5">
                          <div v-for="user in downvoteUserList" class="dropdown_color">
                            <div class="pointer font-14" @click="goUserData(user.userName)">+ {{ user.userName }}</div>
                          </div>
                          <div v-show="posting.postingGoodnums > 20">
                            <div @click="getDownvoteUser">……</div>
                          </div>
                        </div>
                        <!-- - - - -  - 转发模态框- - - - - - - -->
                        <v-dialog v-model="forwardModal" persistent max-width="600px">
                          <v-card>
                            <v-card-title>
                              <span class="font-30">{{ $t('posting.retweet') }}</span>
                            </v-card-title>
                            <v-list two-line>
                              <v-list-tile>
                                <v-list-tile-avatar>
                                  <!-- <span @click="goUserData(userDetail.nickName)" class="pointer user-avatar">
                                  <img class="img-responsive rounded-circle posting-img" :src="userDetail.image">
                                  </span>-->
                                  <v-avatar color="primary" class="pointer" size="40" @click="goUserData(userDetail.userName)">
                                    <img v-show="userDetail.image != null" :src="userDetail.image" :alt="userDetail.userName">
                                    <span v-show="userDetail.image == null" class="white--text">
                                      {{ userDetail.userName != null ? userDetail.userName.trim().substring(0, 1).toLocaleUpperCase(): ''}}
                                    </span>
                                  </v-avatar>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <v-list-tile-title>
                                    <span @click="goUserData(userDetail.nickName)" class="pointer font-18">
                                      {{ userDetail.nickName }}
                                      <span>({{ userDetail.reputationScore }})</span>
                                    </span>
                                    <span class="px-2 font-16">
                                      {{ $t('common.at') }}
                                      <v-icon size="18">schedule</v-icon>
                                      {{ dateFormat(posting.postingTime) }}
                                    </span>
                                  </v-list-tile-title>
                                  <v-list-tile-sub-title>
                                    <span class="font-18">{{ posting.postingTitle }}</span>
                                  </v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-list>
                            <v-card-text>
                              <v-container grid-list-md>
                                <v-layout wrap>
                                  <v-flex xs12 sm6 md12>
                                    <v-form ref="formValidatezf">
                                      <v-textarea solo name="input-7-4" v-model="formValidatezf.postingForwardContext"></v-textarea>
                                    </v-form>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn class="primary" flat @click="forwardModal = false">Close</v-btn>
                              <v-btn class="primary" flat @click="postingforward">Save</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </span>
                    </div>
                  </div>
                </div>
                <!--*********************************第一级(父级)评论BEGIN*******************************-->
                <div class="mt-5" v-show="isShowcomments">
                  <!-- 给帖子的评论框 -->
                  <v-form ref="formValidate">
                    <quill-editor v-model="formValidate.commentsContext" ref="myQuillEditor" class="mt-3 postCommentOfEditor" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)" @change="onEditorChange($event)"></quill-editor>
                    <v-btn color="primary" @click="postingcomments('formValidate')">{{ $t('common.submit') }}</v-btn>
                    <v-btn color="primary" @click="isShowcomments = false">{{ $t('common.cancel') }}</v-btn>
                  </v-form>
                </div>
                <div class="mb-5 mt-3">
                  <div class="border-bottom-light-1 pt-2"></div>
                </div>
                <!--  -->
                <div class="mb-3">
                  <h2 class="primary--text" v-show="postingCommentList != null && postingCommentList.length > 0">{{ $t('postingsel.DISCUSSION') }}</h2>
                </div>

                <div id="comments">
                  <!--评论-->
                  <div v-for="(com, index) in postingCommentList" v-show="com.parentCommentId == null" :id="com.commentsId" class="my-5">
                    <span class="right pointer" @click="commentsUporDown($event, com)">
                      <Icon :title="$t('postingsel.UporDown')" size="20" type="chevron-down"></Icon>
                    </span>
                    <dl v-for="(commentuser, index) in usercommentsList" v-if="com.commentsUserId == commentuser.userId" class="font-14 d-custom-flex">
                      <dt>
                        <!-- - - - - - - - - 评论人头像- - - - - - - - - - - - - -->
                        <v-avatar color="primary" class="pointer" size="32" @click="goUserData(commentuser.userName)">
                          <img v-show="commentuser.image != null" :src="commentuser.image" :alt="commentuser.userName">
                          <span v-show="commentuser.image == null" class="headline white--text">
                            {{commentuser.userName != null ? commentuser.userName.trim().substring(0, 1).toLocaleUpperCase(): ''}}
                          </span>
                        </v-avatar>
                      </dt>
                      <dd class="ml-2">
                        <span class="pointer font-16" @click="goUserData(commentuser.userName)">
                          {{ commentuser.nickName }}
                          <span>({{ commentuser.reputationScore }})</span>
                        </span>
                        <span>·</span>
                        <span class="font-14">{{ dateFormat(com.commentsTime) }}</span>
                        <div v-show="com.cupordown">
                          <!-- 显示第一级评论 -->
                          <div v-if="com.editCommentsFlag">
                            <div class="font-14 mt-3" v-html="com.commentsContext"></div>
                            <div class="social-list mt-3">
                              <div v-show="postingCommentsEvaluationList != null">
                                <ul v-for="(pce, index) in postingCommentsEvaluationList" :key="index" class="list-inline d-inline-block">
                                  <li v-show="pce.commentsId == com.commentsId && pce.eStatus == 0">
                                    <v-icon small :title="$t('posting.bonus')">fas fa-dollar-sign</v-icon>
                                    <span class="font-14 ml-1">{{ com.bonus != null ? com.bonus.toFixed(2) : 0.0 }}</span>
                                    <v-icon small color="primary" :title="$t('postingsel.upvote')" @click="evaluateComment(com.commentsId, '0')">thumb_up_alt</v-icon>
                                    <!--赞评论-->
                                    <span class="font-14 ml-1">{{ com.postingCommentsGoodnums }}</span>
                                    <v-icon small :title="$t('postingsel.tread')" @click="evaluateComment(com.commentsId, '1')">thumb_down_alt</v-icon>
                                    <span class="font-14 ml-1">{{ com.postingCommentsStepnums }}</span>
                                    <!--踩评论-->
                                    <v-icon small :title="$t('posting.comment')" @click="changeData(com)">fa fa-comment</v-icon>
                                    <span class="font-14 ml-1">{{ com.childCommentsNumber }}</span>
                                    <!--子评论数量-->
                                    <v-icon small :title="$t('common.edit')" v-show="user != null && com.commentsUserId == user.userId" @click="editComment(com)">edit</v-icon>
                                    <!-- 编辑评论 -->
                                  </li>
                                  <li v-show="pce.commentsId == com.commentsId && pce.eStatus == 1">
                                    <v-icon small :title="$t('posting.bonus')">fas fa-dollar-sign</v-icon>
                                    <span class="font-14 ml-1">{{ com.bonus != null ? com.bonus.toFixed(2) : 0.0 }}</span>
                                    <v-icon small :title="$t('postingsel.upvote')" @click="evaluateComment(com.commentsId, '0')">thumb_up_alt</v-icon>
                                    <!--赞评论-->
                                    <span class="font-14 ml-1">{{ com.postingCommentsGoodnums }}</span>
                                    <v-icon small color="primary" :title="$t('postingsel.tread')" @click="evaluateComment(com.commentsId, '1')">thumb_down_alt</v-icon>
                                    <span class="font-14 ml-1">{{ com.postingCommentsStepnums }}</span>
                                    <!--踩评论-->
                                    <v-icon small :title="$t('posting.comment')" @click="changeData(com)">fa fa-comment</v-icon>
                                    <span class="font-14 ml-1">{{ com.childCommentsNumber }}</span>
                                    <!--子评论数量-->
                                    <v-icon small :title="$t('common.edit')" v-show="user != null && com.commentsUserId == user.userId" @click="editComment(com)">edit</v-icon>
                                    <!-- 编辑评论 -->
                                  </li>
                                  <li v-show="pce.commentsId == com.commentsId && pce.eStatus == -1">
                                    <v-icon small :title="$t('posting.bonus')">fas fa-dollar-sign</v-icon>
                                    <span class="font-14 ml-1">{{ com.bonus != null ? com.bonus.toFixed(2) : 0.0 }}</span>
                                    <v-icon small :title="$t('postingsel.upvote')" @click="evaluateComment(com.commentsId, '0')">thumb_up_alt</v-icon>
                                    <!--赞评论-->
                                    <span class="font-14 ml-1">{{ com.postingCommentsGoodnums }}</span>
                                    <v-icon small :title="$t('postingsel.tread')" @click="evaluateComment(com.commentsId, '1')">thumb_down_alt</v-icon>
                                    <span class="font-14 ml-1">{{ com.postingCommentsStepnums }}</span>
                                    <!--踩评论-->
                                    <v-icon small :title="$t('posting.comment')" @click="changeData(com)">fa fa-comment</v-icon>
                                    <span class="font-14 ml-1">{{ com.childCommentsNumber }}</span>
                                    <!--子评论数量-->
                                    <v-icon small :title="$t('common.edit')" v-show="user != null && com.commentsUserId == user.userId" @click="editComment(com)">edit</v-icon>
                                    <!-- 编辑评论 -->
                                  </li>
                                </ul>
                              </div>
                              <div v-show="postingCommentsEvaluationList == null">
                                <ul class="list-inline d-inline-block">
                                  <li>
                                    <v-icon small :title="$t('posting.bonus')">fas fa-dollar-sign</v-icon>
                                    <span>{{ com.bonus != null ? com.bonus.toFixed(2) : 0.0 }}</span>
                                    <v-icon small :title="$t('postingsel.upvote')" @click="evaluateComment(com.commentsId, '0')">thumb_up_alt</v-icon>
                                    <!--赞评论-->
                                    <span>{{ com.postingCommentsGoodnums }}</span>
                                    <v-icon small :title="$t('postingsel.tread')" @click="evaluateComment(com.commentsId, '1')">thumb_down_alt</v-icon>
                                    <span>{{ com.postingCommentsStepnums }}</span>
                                    <!--踩评论-->
                                    <v-icon small :title="$t('posting.comment')" @click="changeData(com)">fa fa-comment</v-icon>
                                    <span>{{ com.childCommentsNumber }}</span>
                                    <!--子评论数量-->
                                    <v-icon small :title="$t('common.edit')" v-show="user != null && com.commentsUserId == user.userId" @click="editComment(com)">edit</v-icon>
                                    <!-- 编辑评论 -->
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <!--给第一级评论的回复框-->
                            <div class="postingreplys" v-if="com.cshow">
                              <v-form ref="formValidatereply">
                                <v-text-field v-model="com.commentsId" class="d-none"></v-text-field>
                                <quill-editor v-model="formValidatereply.commentsContext" ref="myQuillEditor" class="mt-3 postCommentOfEditor" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)" @change="onEditorChange($event)"></quill-editor>
                                <v-btn color="primary" @click="postingreplys('formValidatereply', com)">{{ $t('common.submit') }}</v-btn>
                                <v-btn color="primary" type="ghost" @click.prevent="postingreplyclose(com)">{{ $t('common.cancel') }}</v-btn>
                              </v-form>
                            </div>
                          </div>
                          <!-- 编辑第一级评论 -->
                          <div v-else>
                            <v-form>
                              <quill-editor v-model="editCommentsContext" ref="myQuillEditor" class="mt-3 postCommentOfEditor" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)" @change="onEditorChange($event)"></quill-editor>
                              <v-btn color="primary" @click="updateComment(com)">{{ $t('common.submit') }}</v-btn>
                              <v-btn color="primary" type="ghost" @click.prevent="com.editCommentsFlag = !com.editCommentsFlag">{{ $t('common.cancel') }}</v-btn>
                            </v-form>
                          </div>
                          <!--*********************************第二级评论BEGIN*******************************-->
                          <div v-for="(rep, index) in com.postingCommentList" v-if="rep.parentCommentId != null" class="mt-5">
                            <span class="right pointer pos-absolute ml-71" @click="commentsUporDown($event, rep)">
                              <Icon size="20" :title="$t('postingsel.UporDown')" type="chevron-down"></Icon>
                            </span>
                            <div v-for="(commentuser1, index) in usercommentsList" v-if="rep.commentsUserId == commentuser1.userId" style="display: flex;">
                              <dt>
                                <v-avatar color="primary" class="pointer" size="32" @click="goUserData(commentuser1.userName)">
                                  <img v-show="commentuser1.image != null" :src="commentuser1.image" :alt="commentuser1.userName">
                                  <span v-show="commentuser1.image == null" class="white--text">
                                    {{commentuser1.userName != null ? commentuser1.userName.trim().substring(0, 1).toLocaleUpperCase(): ''}}
                                  </span>
                                </v-avatar>
                              </dt>
                              <dd class="ml-2">
                                <span class="pointer font-16" @click="goUserData(commentuser1.userName)">
                                  {{ commentuser1.nickName }}
                                  <span>({{ commentuser1.reputationScore }})</span>
                                </span>
                                <span>·</span>
                                <span class="font-14">{{ dateFormat(rep.commentsTime) }}</span>
                                <br>
                                <div v-show="rep.cupordown">
                                  <!-- 显示第二级评论 -->
                                  <div v-if="rep.editCommentsFlag">
                                    <div class="font-14 mt-3" v-html="rep.commentsContext"></div>
                                    <div class="social-list mt-3">
                                      <div v-show="postingCommentsEvaluationList != null">
                                        <ul v-for="(pce, index) in postingCommentsEvaluationList" :key="index" class="list-inline d-inline-block">
                                          <li v-show="pce.commentsId == rep.commentsId && pce.eStatus == 0">
                                            <v-icon small :title="$t('posting.bonus')">fas fa-dollar-sign</v-icon>
                                            <span class="font-14">{{ rep.bonus != null ? rep.bonus.toFixed(2) : 0.0 }}</span>
                                            <v-icon small color="primary" :title="$t('postingsel.upvote')" @click="evaluateComment(rep.commentsId, '0')">thumb_up_alt</v-icon>
                                            <!--赞回复-->
                                            <span class="font-14 ml-1">{{ rep.postingCommentsGoodnums }}</span>
                                            <v-icon small :title="$t('postingsel.tread')" @click="evaluateComment(rep.commentsId, '1')">thumb_down_alt</v-icon>
                                            <!--踩回复-->
                                            <span class="font-14 ml-1">{{ rep.postingCommentsStepnums }}</span>
                                            <v-icon small @click="changeData(rep)" :title="$t('posting.comment')">fa fa-comment</v-icon>
                                            <span class="font-14 ml-1">{{ rep.childCommentsNumber }}</span>
                                            <!--子评论数量-->
                                            <v-icon small :title="$t('common.edit')" v-show="user != null && rep.commentsUserId == user.userId" @click="editComment(rep)">edit</v-icon>
                                            <!-- 编辑评论 -->
                                          </li>
                                          <li v-show="pce.commentsId == rep.commentsId && pce.eStatus == 1">
                                            <v-icon small :title="$t('posting.bonus')">fas fa-dollar-sign</v-icon>
                                            <span class="font-14">{{ rep.bonus != null ? rep.bonus.toFixed(2) : 0.0 }}</span>
                                            <v-icon small :title="$t('postingsel.upvote')" @click="evaluateComment(rep.commentsId, '0')">thumb_up_alt</v-icon>
                                            <!--赞回复-->
                                            <span class="font-14 ml-1">{{ rep.postingCommentsGoodnums }}</span>
                                            <v-icon small color="primary" :title="$t('postingsel.tread')" @click="evaluateComment(rep.commentsId, '1')">thumb_down_alt</v-icon>
                                            <!--踩回复-->
                                            <span class="font-14 ml-1">{{ rep.postingCommentsStepnums }}</span>
                                            <v-icon small @click="changeData(rep)" :title="$t('posting.comment')">fa fa-comment</v-icon><
                                            <span class="font-14 ml-1">{{ rep.childCommentsNumber }}</span>
                                            <!--子评论数量-->
                                            <v-icon small :title="$t('common.edit')" v-show="user != null && rep.commentsUserId == user.userId" @click="editComment(rep)">edit</v-icon>
                                            <!-- 编辑评论 -->
                                          </li>
                                          <li v-show="pce.commentsId == rep.commentsId && pce.eStatus == -1">
                                            <v-icon small :title="$t('posting.bonus')">fas fa-dollar-sign</v-icon>
                                            <span class="font-14">{{ rep.bonus != null ? rep.bonus.toFixed(2) : 0.0 }}</span>
                                            <v-icon small :title="$t('postingsel.upvote')" @click="evaluateComment(rep.commentsId, '0')">thumb_up_alt</v-icon>
                                            <!--赞回复-->
                                            <span class="font-14 ml-1">{{ rep.postingCommentsGoodnums }}</span>
                                            <v-icon small :title="$t('postingsel.tread')" @click="evaluateComment(rep.commentsId, '1')">thumb_down_alt</v-icon>
                                            <!--踩回复-->
                                            <span class="font-14 ml-1">{{ rep.postingCommentsStepnums }}</span>
                                            <v-icon small @click="changeData(rep)" :title="$t('posting.comment')">fa fa-comment</v-icon>
                                            <span class="font-14 ml-1">{{ rep.childCommentsNumber }}</span>
                                            <!--子评论数量-->
                                            <v-icon small :title="$t('common.edit')" v-show="user != null && rep.commentsUserId == user.userId" @click="editComment(rep)">edit</v-icon>
                                            <!-- 编辑评论 -->
                                          </li>
                                        </ul>
                                      </div>
                                      <div v-show="postingCommentsEvaluationList == null">
                                        <ul class="list-inline d-inline-block">
                                          <li>
                                            <v-icon small :title="$t('posting.bonus')">fas fa-dollar-sign</v-icon>
                                            <span class="font-14">{{ rep.bonus != null ? rep.bonus.toFixed(2) : 0.0 }}</span>
                                            <v-icon small :title="$t('postingsel.upvote')" @click="evaluateComment(rep.commentsId, '0')">thumb_up_alt</v-icon>
                                            <!--赞回复-->
                                            <span class="font-14 ml-1">{{ rep.postingCommentsGoodnums }}</span>
                                            <v-icon small :title="$t('postingsel.tread')" @click="evaluateComment(rep.commentsId, '1')">thumb_down_alt</v-icon>
                                            <!--踩回复-->
                                            <span class="font-14 ml-1">{{ rep.postingCommentsStepnums }}</span>
                                            <v-icon small @click="changeData(rep)" :title="$t('posting.comment')">fa fa-comment</v-icon>
                                            <span class="font-14 ml-1">{{ rep.childCommentsNumber }}</span>
                                            <!--子评论数量-->
                                            <v-icon small :title="$t('common.edit')" v-show="user != null && rep.commentsUserId == user.userId" @click="editComment(rep)">edit</v-icon>
                                            <!-- 编辑评论 -->
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <!--给第二级评论的回复框-->
                                    <div class="postingreplys" v-if="rep.cshow">
                                      <v-form ref="formValidatereply">
                                        <v-text-field v-model="rep.commentsId" class="d-none"></v-text-field>
                                        <quill-editor v-model="formValidatereply.commentsContext" ref="myQuillEditor" class="mt-3 postCommentOfEditor" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)" @change="onEditorChange($event)"></quill-editor>
                                        <v-btn color="primary" @click="postingreplys('formValidatereply', rep)">{{ $t('postingcreate.Post') }}</v-btn>
                                        <v-btn color="primary" type="ghost" @click.prevent="postingreplyclose(rep)">{{ $t('common.cancel') }}</v-btn>
                                      </v-form>
                                    </div>
                                  </div>
                                  <!-- 编辑第二级评论 -->
                                  <div v-else>
                                    <v-form>
                                      <quill-editor v-model="editCommentsContext" ref="myQuillEditor" class="mt-3 postCommentOfEditor" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)" @change="onEditorChange($event)"></quill-editor>
                                      <v-btn color="primary" @click="updateComment(rep)">{{ $t('common.submit') }}</v-btn>
                                      <v-btn color="primary" type="ghost" @click.prevent="rep.editCommentsFlag = !rep.editCommentsFlag">{{ $t('common.cancel') }}</v-btn>
                                    </v-form>
                                  </div>
                                  <!--*********************************第三级评论BEGIN*******************************-->
                                  <div v-for="(reptorep, index) in rep.postingCommentList" class="mt-5">
                                    <span class="pointer right pos-absolute ml-68"  @click="commentsUporDown($event, reptorep)">
                                      <Icon :title="$t('postingsel.UporDown')" size="20" type="chevron-down"></Icon>
                                    </span>
                                    <div v-for="(commentuser2, index) in usercommentsList" v-if="reptorep.commentsUserId == commentuser2.userId" class="d-custom-flex font-14">
                                      <dt>
                                        <v-avatar color="primary" class="pointer" size="32" @click="goUserData(commentuser2.userName)">
                                          <img v-show="commentuser2.image != null" :src="commentuser2.image" :alt="commentuser2.userName">
                                          <span v-show="commentuser2.image == null" class="white--text">
                                            {{commentuser2.userName != null ? commentuser2.userName.trim().substring(0, 1).toLocaleUpperCase(): ''}}
                                          </span>
                                        </v-avatar>
                                      </dt>
                                      <dd style="margin-left: 10px;">
                                        <span class="pointer font-16" @click="goUserData(commentuser2.userName)">
                                          {{ commentuser2.nickName }}
                                          <span>({{ commentuser2.reputationScore }})</span>
                                        </span>
                                        <span>·</span>
                                        <span class="font-14">{{ dateFormat(reptorep.commentsTime) }}</span>
                                        <br>
                                        <div v-show="reptorep.cupordown">
                                          <!-- 显示第三级评论 -->
                                          <div v-if="reptorep.editCommentsFlag">
                                            <div class="font-14 mt-3" v-html="reptorep.commentsContext"></div>
                                            <div class="social-list mt-3 mb-4">
                                              <div v-show="postingCommentsEvaluationList != null">
                                                <ul v-for="(pce, index) in postingCommentsEvaluationList" :key="index" class="list-inline d-inline-block">
                                                  <li v-show="pce.commentsId == reptorep.commentsId && pce.eStatus == 0">
                                                    <v-icon small :title="$t('posting.bonus')">fas fa-dollar-sign</v-icon>
                                                    <span class="font-14">{{ reptorep.bonus != null ? reptorep.bonus.toFixed(2) : 0.0 }}</span>
                                                    <v-icon small color="primary" :title="$t('postingsel.upvote')" @click="evaluateComment(reptorep.commentsId, '0')">thumb_up_alt</v-icon>
                                                    <!--赞二级回复-->
                                                    <span class="font-14 ml-1">{{ reptorep.postingCommentsGoodnums }}</span>
                                                    <v-icon small :title="$t('postingsel.tread')" @click="evaluateComment(reptorep.commentsId, '1')">thumb_down_alt</v-icon>
                                                    <!--踩二级回复-->
                                                    <span class="font-14 ml-1">{{ reptorep.postingCommentsStepnums }}</span>
                                                    <v-icon small @click="changereplytoreply(reptorep, commentuser2)" :title="$t('posting.comment')">fa fa-comment</v-icon>
                                                    <span class="font-14 ml-1">{{ reptorep.childCommentsNumber }}</span>
                                                    <!--子评论数量-->
                                                    <v-icon small :title="$t('common.edit')" v-show="user != null && reptorep.commentsUserId == user.userId" @click="editComment(reptorep)">edit</v-icon>
                                                    <!-- 编辑评论 -->
                                                  </li>
                                                  <li v-show="pce.commentsId == reptorep.commentsId && pce.eStatus == 1">
                                                    <v-icon small :title="$t('posting.bonus')">fas fa-dollar-sign</v-icon>
                                                    <span class="font-14">{{ reptorep.bonus != null ? reptorep.bonus.toFixed(2) : 0.0 }}</span>
                                                    <v-icon small :title="$t('postingsel.upvote')" @click="evaluateComment(reptorep.commentsId, '0')">thumb_up_alt</v-icon>
                                                    <!--赞二级回复-->
                                                    <span class="font-14 ml-1">{{ reptorep.postingCommentsGoodnums }}</span>
                                                    <v-icon small color="primary" :title="$t('postingsel.tread')" @click="evaluateComment(reptorep.commentsId, '1')">thumb_down_alt</v-icon>
                                                    <!--踩二级回复-->
                                                    <span class="font-14 ml-1">{{ reptorep.postingCommentsStepnums }}</span>
                                                    <v-icon small @click="changereplytoreply(reptorep, commentuser2)":title="$t('posting.comment')">fa fa-comment</v-icon>
                                                    <span class="font-14 ml-1">{{ reptorep.childCommentsNumber }}</span>
                                                    <!--子评论数量-->
                                                    <v-icon small :title="$t('common.edit')" v-show="user != null && reptorep.commentsUserId == user.userId" @click="editComment(reptorep)">edit</v-icon>
                                                    <!-- 编辑评论 -->
                                                  </li>
                                                  <li v-show="pce.commentsId == reptorep.commentsId && pce.eStatus == -1">
                                                    <v-icon small :title="$t('posting.bonus')">fas fa-dollar-sign</v-icon>
                                                    <span class="font-14 ml-1">{{ reptorep.bonus != null ? reptorep.bonus.toFixed(2) : 0.0 }}</span>
                                                    <v-icon small :title="$t('postingsel.upvote')" @click="evaluateComment(reptorep.commentsId, '0')">thumb_up_alt</v-icon>
                                                    <!--赞二级回复-->
                                                    <span class="font-14 ml-1">{{ reptorep.postingCommentsGoodnums }}</span>
                                                    <v-icon small :title="$t('postingsel.tread')" @click="evaluateComment(reptorep.commentsId, '1')">thumb_down_alt</v-icon>
                                                    <!--踩二级回复-->
                                                    <span class="font-14 ml-1">{{ reptorep.postingCommentsStepnums }}</span>
                                                    <v-icon small @click="changereplytoreply(reptorep, commentuser2)" :title="$t('posting.comment')">fa fa-comment</v-icon>
                                                    <span class="font-14 ml-1">{{ reptorep.childCommentsNumber }}</span>
                                                    <!--子评论数量-->
                                                    <v-icon small :title="$t('common.edit')" v-show="user != null && reptorep.commentsUserId == user.userId" @click="editComment(reptorep)">edit</v-icon>
                                                    <!-- 编辑评论 -->
                                                  </li>
                                                </ul>
                                              </div>
                                              <div v-show="postingCommentsEvaluationList == null">
                                                <ul class="list-inline d-inline-block">
                                                  <li>
                                                    <v-icon small :title="$t('posting.bonus')">fas fa-dollar-sign</v-icon>
                                                    <span class="font-14">{{ reptorep.bonus != null ? reptorep.bonus.toFixed(2) : 0.0 }}</span>
                                                    <v-icon small :title="$t('postingsel.upvote')" @click="evaluateComment(reptorep.commentsId, '0')">thumb_up_alt</v-icon>
                                                    <!--赞二级回复-->
                                                    <span class="font-14 ml-1">{{ reptorep.postingCommentsGoodnums }}</span>
                                                    <v-icon small :title="$t('postingsel.tread')" @click="evaluateComment(reptorep.commentsId, '1')">thumb_down_alt</v-icon>
                                                    <!--踩二级回复-->
                                                    <span class="font-14 ml-1">{{ reptorep.postingCommentsStepnums }}</span>
                                                    <v-icon small @click="changereplytoreply(reptorep, commentuser2)" :title="$t('posting.comment')">fa fa-comment</v-icon>
                                                    <span class="font-14 ml-1">{{ reptorep.childCommentsNumber }}</span>
                                                    <!--子评论数量-->
                                                    <v-icon small :title="$t('common.edit')" v-show="user != null && reptorep.commentsUserId == user.userId" @click="editComment(reptorep)">edit</v-icon>
                                                    <!-- 编辑评论 -->
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                            <!--给第三级评论的回复框-->
                                            <div class="postingreplys" v-if="reptorep.cshow">
                                              <v-form ref="formValidatereplytoreply">
                                                <v-text-field v-model="rep.commentsId" class="d-none"></v-text-field>
                                                <quill-editor v-model="formValidatereplytoreply.commentsContext" ref="myQuillEditor" class="mt-3 postCommentOfEditor" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)" @change="onEditorChange($event)"></quill-editor>
                                                <v-btn color="primary" @click="postingreplytoreplys('formValidatereplytoreply', rep)">{{ $t('common.submit') }}</v-btn>
                                                <v-btn color="primary" @click.prevent="postingreplyclose(reptorep)" class="primary white--text">{{ $t('common.cancel') }}</v-btn>
                                              </v-form>
                                            </div>
                                          </div>
                                          <!-- 编辑第三级评论 -->
                                          <div v-else>
                                            <v-form>
                                              <quill-editor v-model="editCommentsContext" ref="myQuillEditor" class="mt-3 postCommentOfEditor" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)" @change="onEditorChange($event)"></quill-editor>
                                              <v-btn color="primary" @click="updateComment(reptorep)">{{ $t('common.submit') }}</v-btn>
                                              <v-btn color="primary" type="ghost" @click.prevent="reptorep.editCommentsFlag = !reptorep.editCommentsFlag">{{ $t('common.cancel') }}</v-btn>
                                            </v-form>
                                          </div>
                                        </div>
                                      </dd>
                                    </div>
                                  </div>
                                  <!--*********************************第三级评论END*******************************-->
                                </div>
                              </dd>
                            </div>
                          </div>
                          <!--*********************************第二级评论END*******************************-->
                        </div>
                      </dd>
                    </dl>
                  </div>
                </div>
                <!--*********************************第一级(父级)评论END*******************************-->
            
          </v-flex>
        </v-layout>
      </v-container>
    </div>
</template>
<style>
.share-icon .material-icons {
  display: inherit !important;
}
div.postCommentOfEditor .ql-container,
.editr--content {
  min-height: 150px !important;
  min-width: 200px;
}
div.postCommentOfEditor .ql-container {
  overflow-y: scroll;
  max-height: 150px;
  max-width: 760px;
}
div.postCommentOfEditor .ql-toolbar {
  max-width: 760px;
}
</style>
<script>
import { mapGetters } from "vuex";
import config from "../../config.js";
import QuillEditor from "vue-quill-editor";
export default {
  data() {
    return {
      editorOption: {}, // some quill options
      username: this.$route.params.username, //用户的ID
      postingId: this.$route.params.postingId, //该帖子的id
      postingTitle: this.$route.params.postingTitle, //帖子标题
      isLoading: true, //是否显示加载中
      forwardModal: false, // 转发按钮
      isShowViewImageModal: false, //是否显示查看大图的modal
      postingForwardIdDetail: "", //保存转发用户信息
      fab: false, //分享悬浮按钮
      colorGoodnum: "", //点赞变色
      colorStepnum: "", //踩变色
      divIndex: -1,
      posting: {}, //保存的帖子对象
      userDetail: {}, //保存的当前用户对象
      usercommentsList: [], //保存评论用户信息
      postingCommentList: [], //保存的当前评论对象
      postingCommentsEvaluationgoods: [], //保存当前用户是否点过赞评论
      postingCommentsEvaluationsteps: [], //保存当前用户是否踩评论
      collectionPostingList: [], //收藏的帖子集合
      isShowUpvoteUserDiv: false, //是否显示点赞用户div
      isShowDownvoteUserDiv: false, //是否显示点踩用户div
      upvoteUserList: [], //给该帖子点赞的用户集合
      downvoteUserList: [], //给该帖子点踩的用户集合
      s: localStorage.getItem("token"), //保存的当前回复对象
      isuserinfoShow: false, //第一次出现用户的详情
      isuserinfoShow1: false, //第二次出现用户的详情
      isShowcomments: false, //评论
      replyShow: true,
      replysubmit: true,
      modal2: false, //是否显示转发模态框
      isFollow: false, //是否已关注
      formFollow: {
        //关注
        userId: "",
        followerId: ""
      },
      formValidate: {
        //评价帖子
        commentsContext: ""
      },
      formCollection: {
        //收藏
        userId: "",
        postingId: ""
      },
      formEvaluation: {
        //是否评价(赞/踩)
        userId: "",
        postingId: ""
      },
      ruleValidate: {
        //评价帖子验证
        commentsContext: [
          {
            required: true,
            message: this.$t("postingsel.Tocomment"),
            trigger: "blur"
          },
          {
            type: "string",
            min: 20,
            message: this.$t("postingsel.TocommentLength"),
            trigger: "blur"
          }
        ]
      },
      formValidatezf: {
        //转发帖子
        postingUserforwardId: this.$store.state.user.id,
        postingId: this.$route.params.postingId,
        postingForwardContext: ""
      },
      ruleValidatezf: {
        //转发帖子验证
        postingForwardContext: [
          {
            required: false,
            message: this.$t("postingsel.Tocomment"),
            trigger: "blur"
          },
          {
            type: "string",
            min: 20,
            message: this.$t("postingsel.TocommentLength"),
            trigger: "blur"
          }
        ]
      },
      formValidatereply: {
        //回复
        commentsContext: "",
        commentsId: ""
      },
      ruleValidatereply: {
        //回复表单验证
        commentsContext: [
          {
            required: true,
            message: this.$t("postingsel.Tocomment"),
            trigger: "blur"
          },
          {
            type: "string",
            max: 200,
            message: this.$t("postingsel.TocommentMaxLength"),
            trigger: "blur"
          }
        ]
      },
      formValidatereplytoreply: {
        //二级回复
        commentsContext: "",
        commentsId: ""
      },
      commentsEvaluation: {
        //评论评价对象
        userId: this.$store.state.user.id,
        commentsId: "",
        eStatus: ""
      },
      postingCommentsEvaluationList: null, //评论点赞/踩的对象集合
      editCommentsContext: null //更新评论时的评论内容
    };
  },
  computed: {
    ...mapGetters(["user", "marketsList"]),
    isLogin() {
      if (
        this.$store.state.user.token != null &&
        this.$store.state.user.token != ""
      ) {
        return true;
      } else {
        return false;
      }
    },
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  created() {},
  mounted() {
    this.postingbyid();
  },
  watch: {
    $route() {
      this.postingId = this.$route.params.postingId;
    },
    postingId() {
      if (this.postingId != null) {
        //查询数据
        this.postingbyid();
        //清空评论
        this.postingCommentList = [];
      }
    }
  },
  methods: {
    onEditorReady(editor) {},
    onEditorBlur(editor) {},
    onEditorFocus(editor) {},
    onEditorChange({ editor, html, text }) {},
    //根据标签查找帖子
    findtagposting(tagName) {
      if (tagName != null && tagName.trim() != "") {
        this.$router.push({ name: "tagPosts", params: { tagName: tagName } });
      }
    },
    //点击其它区域隐藏区块
    hideBlock(event) {
      //点赞和踩的div
      var upvoteUserDiv = document.getElementById("upvoteUserDiv");
      if (upvoteUserDiv) {
        if (!upvoteUserDiv.contains(event.target)) {
          var faSortDownIcon = document.getElementsByClassName(
            "fa-fort-down-icon"
          );
          var flag = false;
          for (var i = 0; i < faSortDownIcon.length; i++) {
            if (faSortDownIcon[i].contains(event.target)) {
              flag = true;
            }
          }
          if (!flag) {
            //如果是false，说明不是其中某一个icon，关闭div
            this.isShowUpvoteUserDiv = false;
            this.isShowDownvoteUserDiv = false;
            document
              .getElementById("comments")
              .setAttribute("style", "margin-bottom: 0px");
          }
        }
      }
    },
    //查看用户详情页面
    goUserData(username) {
      this.$router.push({
        name: "userData",
        params: {
          username: "@" + username
        }
      });
    },
    //关注
    follow() {
      this.formFollow.userId = this.$store.state.user.id;
      this.formFollow.followerId = this.posting.postingUserId;
      this.$http
        .post(config.baseUrl + "follow/saveFollow", this.formFollow)
        .then(successData => {
          let data = successData.data;
          if (data.resCode == 0) {
            this.isFollow = true;
          } else if (data.resCode == 1) {
            this.isFollow = false;
          } else if (data.resCode == -3) {
            this.$Message.error("Can not follow yourself!");
          }
        });
    },
    commentsUporDown(event, com) {
      if (com.cupordown == true) {
        com.cupordown = false;
        event.target.className = "ivu-icon ivu-icon-chevron-up";
      } else {
        com.cupordown = true;
        event.target.className = "ivu-icon ivu-icon-chevron-down";
      }
    },
    //点击回复弹出回复框
    changeData(com) {
      if (localStorage.getItem("token")) {
        if (com.cshow == true) {
          this.formValidate.commentsContext = "";
          this.formValidatereply.commentsContext = "";
          this.formValidatereplytoreply.commentsContext = "";
          com.cshow = false;
        } else {
          com.cshow = true;
        }
      } else {
        this.$store.state.loginModal = true;
      }
    },
    //点击回复弹出回复框
    changereplytoreply(reptorep, commentuser2) {
      if (localStorage.getItem("token")) {
        this.replyShow = true;
        this.replysubmit = true;
        if (reptorep.cshow == true) {
          reptorep.cshow = false;
        } else {
          reptorep.cshow = true;
          this.formValidatereplytoreply.commentsContext =
            "@" + commentuser2.userName + ":";
        }
      } else {
        this.$store.state.loginModal = true;
      }
    },
    //点击箭头其他隐藏，当前显示
    toggletext(com) {
      if (com.cupordown == false) {
        com.cupordown = true;
      } else {
        com.cupordown = false;
      }
    },
    //评论用户信息显示
    toggleuserinfocomments(com) {
      if (com.commentsUserDetalinfo == true) {
        com.commentsUserDetalinfo = false;
      } else {
        com.commentsUserDetalinfo = true;
      }
    },
    //根据postingId查询帖子
    postingbyid() {
      var postingId = this.$route.params.postingId;
      if (postingId == null || postingId == "") {
        return;
      }
      this.isLoading = true;
      //根据id查询帖子
      let url = config.baseUrl + "posting/open/sel/" + postingId;
      this.$http.get(url).then(successData => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.posting = data.result;
          //设置浏览器标题
          document.title = this.posting.postingTitle;
          this.isLoading = false;
          //根据帖子id查询该帖子的评论
          this.getCommentsByPostingId();
          //查看用户信息
          this.getUserDetailByUserId();
          //如果用户登录，查询用户是否点赞/踩/收藏/关注用户
          if (localStorage.getItem("token")) {
            this.getOperationStatus(postingId);
          }
          //转发的用户详情
          if (data.result.postingUserForwardId != null) {
            let forwordUserUrl =
              config.baseUrl +
              "user/open/userDetail/" +
              data.result.postingUserForwardId;
            this.$http.get(forwordUserUrl).then(successData => {
              this.postingForwardIdDetail = successData.data.result;
            });
          }
        } else {
          this.posting = {};
          this.isLoading = false;
          this.$router.push({ name: "page404" });
        }
      });
    },
    //根据帖子id查询该帖子的评论
    getCommentsByPostingId() {
      let url =
        config.baseUrl + "comments/open/selbypostingid/" + this.postingId;
      this.$http.get(url).then(successData => {
        let data = successData.data;
        this.usercommentsList = data.result.usercommentsList;
        this.postingCommentList = data.result.postingCommentList;
      });
    },
    //根据用户id查询用户详情
    getUserDetailByUserId() {
      let userUrl =
        config.baseUrl +
        "userDetail/open/getSimpleUserDetailByUserId/" +
        this.posting.postingUserId;
      this.$http.get(userUrl).then(successData => {
        this.userDetail = successData.data.result;
      });
    },
    //如果用户登录，查询用户是否点赞/踩/收藏/关注用户
    getOperationStatus(postingId) {
      //查询当前用户是否点过赞/踩
      let evaluationUrl = config.baseUrl + "posting/getPostingEvaluation";
      this.formEvaluation.userId = this.$store.state.user.id;
      this.formEvaluation.postingId = postingId;
      this.$http.post(evaluationUrl, this.formEvaluation).then(successData => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.posting.postingStatus = data.result.eStatus;
        }
      });
      //查询当前用户是否收藏该帖子
      let collectionUrl = config.baseUrl + "collection/isCollection";
      this.formCollection.userId = this.$store.state.user.id;
      this.formCollection.postingId = this.posting.postingId;
      this.$http.post(collectionUrl, this.formCollection).then(successData => {
        let data = successData.data;
        if (data.result == true) {
          this.posting.postingCollection = 0;
        } else {
          this.posting.postingCollection = -1;
        }
      });
      //查询是否已经关注了该用户
      this.formFollow.userId = this.$store.state.user.id;
      this.formFollow.followerId = this.posting.postingUserName;
      this.$http
        .post(config.baseUrl + "follow/isFollow", this.formFollow)
        .then(successData => {
          this.isFollow = successData.data.result;
        });
      //查询当前用户是否给帖子评论点过赞/踩
      let commentEvaluationUrl =
        config.baseUrl +
        "comments/getPostingCommentsEvaluationList/" +
        postingId +
        "/" +
        this.$store.state.user.id;
      this.$http.get(commentEvaluationUrl).then(successData => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.postingCommentsEvaluationList = data.result;
        } else {
          this.postingCommentsEvaluationList = null;
        }
      });
    },
    //点击评论，弹出评论框
    commentsshow() {
      if (localStorage.getItem("token")) {
        this.isShowcomments = !this.isShowcomments;
      } else {
        this.$store.state.loginModal = true;
      }
    },
    //转发帖子
    postingforward() {
      let url = config.baseUrl + "posting/forward";
      this.$http.post(url, this.formValidatezf).then(
        successData => {
          let data = successData.data;
          this.forwardModal = false;
          if (data.resCode == 0) {
            this.$Message.success({
              content: this.$t("posting.forwardMessage"),
              duration: 2
            });
            this.posting.postingCountForword = data.result;
            this.formValidatezf.postingForwardContext = "";
          } else if (data.resCode == -1) {
            this.$Message.error({
              content: this.$t("common.fail"),
              duration: 2
            });
          }
        },
        error => {
          this.forwardModal = false;
        }
      );
    },
    //点击转发弹出转发框
    modalzf(obj) {
      if (localStorage.getItem("token")) {
        this.formValidatezf.postingId = obj.postingId;
        this.forwardModal = true;
      } else {
        this.$store.state.loginModal = true;
      }
    },
    //收藏帖子
    collectionPosting() {
      if (!localStorage.getItem("token")) {
        this.$store.state.loginModal = true;
        return;
      }
      this.formCollection.userId = this.$store.state.user.id;
      this.formCollection.postingId = this.posting.postingId;
      this.$http
        .post(
          config.baseUrl + "collection/saveCollectionPosting",
          this.formCollection
        )
        .then(successData => {
          let data = successData.data;
          if (data.resCode == 0) {
            this.posting.postingCollection = 0; //已收藏
          } else if (data.resCode == 1) {
            this.posting.postingCollection = -1; //未收藏
          }
        });
    },
    //评论当前的帖子方法
    postingcomments(name) {
      if (this.$refs["formValidate"].validate()) {
        let url =
          config.baseUrl + "comments/create/" + this.$route.params.postingId;
        this.$http.post(url, this.formValidate).then(successData => {
          let data = successData.data;
          if (data.resCode == 0) {
            this.formValidate.commentsContext = "";
            this.postingcommentsclose();
            this.getCommentsByPostingId();
          } else if (data.resCode == -1003) {
            this.$Message.error({
              content: this.$t("postingsel.Tocomment"),
              duration: 2
            });
          }
        });
      } else {
        this.$Message.error(this.$t("common.fail"));
      }
    },
    //回复当前的帖评论方法
    postingreplys(name, com) {
      let postingId = this.$route.params.postingId;
      let url =
        config.baseUrl +
        "comments/createreply/" +
        postingId +
        "/" +
        com.commentsId;
      this.$http.post(url, this.formValidatereply).then(successData => {
        let data = successData.data;
        if (data.resCode == 0) {
          this.formValidatereply.commentsContext = "";
          this.postingreplyclose(com);
          this.getCommentsByPostingId();
        } else if (data.resCode == -1003) {
          this.$Message.error({
            content: this.$t("postingsel.Tocomment"),
            duration: 2
          });
        }
      });
    },
    //回复当前的帖评论方法
    postingreplytoreplys(name, com) {
      let postingId = this.$route.params.postingId;
      let url =
        config.baseUrl +
        "comments/createreply/" +
        postingId +
        "/" +
        com.commentsId;
      if (
        this.formValidatereplytoreply.commentsContext.substring(
          this.formValidatereplytoreply.commentsContext.indexOf(":") + 1
        ) == ""
      ) {
        this.$Message.error({
          content: this.$t("postingsel.Tocomment"),
          duration: 2
        });
      } else {
        let username = this.formValidatereplytoreply.commentsContext.substring(
          this.formValidatereplytoreply.commentsContext.indexOf("@") + 1,
          this.formValidatereplytoreply.commentsContext.indexOf(":")
        );
        let context = this.formValidatereplytoreply.commentsContext.substring(
          this.formValidatereplytoreply.commentsContext.indexOf(":")
        );
        username =
          "<a href='" +
          config.ip +
          "#/user/profile/@" +
          username +
          "'  style='color: #41B8BC;'>" +
          "@" +
          username +
          "</a>";
        this.replyShow = false;
        this.replysubmit = false;
        this.formValidatereplytoreply.commentsContext = username + context;
        this.$http
          .post(url, this.formValidatereplytoreply)
          .then(successData => {
            let data = successData.data;
            if (data.resCode == 0) {
              this.formValidatereplytoreply.commentsContext = "";
              this.postingreplyclose(com);
              this.getCommentsByPostingId();
            } else if (data.resCode == -1003) {
              this.$Message.error({
                content: this.$t("postingsel.Tocomment"),
                duration: 2
              });
            }
          });
      }
    },
    //关闭评论框
    postingcommentsclose() {
      this.isShowcomments = false;
    },
    //关闭回复框
    postingreplyclose(com) {
      com.cshow = false;
      this.formValidatereply.commentsContext = "";
      this.formValidatereplytoreply.commentsContext = "";
    },
    //第一个用户信息显示
    toggleuserinfo() {
      this.isuserinfoShow = !this.isuserinfoShow;
    },
    //第二个用户信息显示
    toggleuserinfo1() {
      this.isuserinfoShow1 = !this.isuserinfoShow1;
    },
    //点赞帖子
    changesup() {
      if (localStorage.getItem("token")) {
        let postingId = this.$route.params.postingId;
        let url = config.baseUrl + "posting/evaluationgood/" + postingId;
        this.$http.get(url).then(successData => {
          let data = successData.data;
          if (data.resCode == 0) {
            //在页面给点赞数加1
            this.posting.postingGoodnums = data.result;
            this.posting.postingStatus = 0;
          } else if (data.resCode == -11) {
            this.$Message.warning(this.$t("posting.evaluation"));
          } else if (data.resCode == -1) {
            this.$Message.warning(this.$t("posting.evaluation"));
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    //踩帖子
    changesdown() {
      if (localStorage.getItem("token")) {
        let postingId = this.$route.params.postingId;
        let url = config.baseUrl + "posting/evaluationstep/" + postingId;
        this.$http.get(url).then(successData => {
          let data = successData.data;
          if (data.resCode == 0) {
            //在页面给点踩数加1
            this.posting.postingStepnums = data.result;
            this.posting.postingStatus = 1;
          } else if (data.resCode == -1) {
            this.$Message.warning(this.$t("posting.evaluation"));
          } else if (data.resCode == -11) {
            this.$Message.warning(this.$t("posting.evaluation"));
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    //给评论点赞点踩
    evaluateComment(commentId, status) {
      if (localStorage.getItem("token")) {
        this.commentsEvaluation.userId = this.$store.state.user.id;
        this.commentsEvaluation.commentsId = commentId;
        this.commentsEvaluation.eStatus = status;
        let url = config.baseUrl + "comments/evaluateComment";
        this.$http.post(url, this.commentsEvaluation).then(successData => {
          let data = successData.data;
          if (data.resCode == 0) {
            //点赞成功
            for (
              var i = 0;
              i < this.postingCommentsEvaluationList.length;
              i++
            ) {
              if (
                this.postingCommentsEvaluationList[i].commentsId == commentId
              ) {
                //将评价状态改为0点赞
                this.postingCommentsEvaluationList[i].eStatus = "0";
                break;
              }
            }
            for (var i = 0; i < this.postingCommentList.length; i++) {
              if (this.postingCommentList[i].commentsId == commentId) {
                this.postingCommentList[i].postingCommentsGoodnums += 1;
                break;
              }
            }
            this.$forceUpdate();
          } else if (data.resCode == 1) {
            //点踩成功
            for (
              var i = 0;
              i < this.postingCommentsEvaluationList.length;
              i++
            ) {
              if (
                this.postingCommentsEvaluationList[i].commentsId == commentId
              ) {
                //将评价状态改为1踩
                this.postingCommentsEvaluationList[i].eStatus = "1";
                break;
              }
            }
            for (var i = 0; i < this.postingCommentList.length; i++) {
              if (this.postingCommentList[i].commentsId == commentId) {
                this.postingCommentList[i].postingCommentsStepnums += 1;
                break;
              }
            }
            this.$forceUpdate();
          } else if (data.resCode == 1000) {
            //已经点赞
            this.$Message.warning(this.$t("posting.evaluation"));
          } else if (data.resCode == 1001) {
            //已经点踩
            this.$Message.warning(this.$t("posting.evaluation"));
          } else if (data.resCode == -1) {
            //参数错误
            this.$Message.error(this.$t("common.fail"));
          }
        });
      } else {
        this.$store.state.loginModal = true;
      }
    },
    //关闭转发框
    postingforwardCancel() {
      this.modal2 = false;
    },
    //点击评论收起
    commentsupanddowm(event) {
      event.target.iscommentsContext = false;
      if (event.target.className == "ivu-icon ivu-icon-chevron-up") {
        event.target.className = "ivu-icon ivu-icon-chevron-down";
      } else {
        event.target.className = "ivu-icon ivu-icon-chevron-up";
      }
    },
    //编辑帖子
    editPosting(post) {
      localStorage.setItem("SIP-editPost", JSON.stringify(post));
      localStorage.removeItem("SIP-tagName");
      this.$router.push({ name: "createPost" });
    },
    // 编辑评论
    editComment(comment) {
      comment.editCommentsFlag = !comment.editCommentsFlag;
      this.editCommentsContext = comment.commentsContext;
    },
    // 更新评论
    updateComment(comment) {
      let api = config.baseUrl + "comments/updateComment";
      var obj = new Object();
      obj.commentsId = comment.commentsId;
      obj.commentsContext = this.editCommentsContext;
      this.$http.post(api, obj).then(
        response => {
          let data = response.data;
          if (data.resCode == 0) {
            comment.commentsContext = data.result;
          }
          comment.editCommentsFlag = true;
        },
        error => {
          comment.editCommentsFlag = true;
        }
      );
    },
    //根据帖子id查询点赞用户
    getUpvoteUser() {
      this.isShowUpvoteUserDiv = !this.isShowUpvoteUserDiv;
      if (!this.isShowUpvoteUserDiv) {
        document
          .getElementById("comments")
          .setAttribute("style", "margin-bottom: 0px");
        return;
      }
      this.upvoteUserList = [];
      this.isShowDownvoteUserDiv = false;
      document
        .getElementById("comments")
        .setAttribute("style", "margin-bottom: 450px");
      let upvoteUrl =
        config.baseUrl +
        "postingEvaluation/open/getUpvoteUserByPostingId?postingId=" +
        this.postingId;
      this.$http.get(upvoteUrl).then(response => {
        let data = response.data;
        if (data.resCode == 0) {
          this.upvoteUserList = data.result;
        } else {
          this.upvoteUserList = [];
        }
      });
    },
    //根据帖子id查询点踩用户
    getDownvoteUser() {
      this.isShowDownvoteUserDiv = !this.isShowDownvoteUserDiv;
      if (!this.isShowDownvoteUserDiv) {
        document
          .getElementById("comments")
          .setAttribute("style", "margin-bottom: 0px");
        return;
      }
      this.downvoteUserList = [];
      this.isShowUpvoteUserDiv = false;
      document
        .getElementById("comments")
        .setAttribute("style", "margin-bottom: 450px");
      let downvoteUrl =
        config.baseUrl +
        "postingEvaluation/open/getDownvoteUserByPostingId?postingId=" +
        this.postingId;
      this.$http.get(downvoteUrl).then(response => {
        let data = response.data;
        if (data.resCode == 0) {
          this.downvoteUserList = data.result;
        } else {
          this.downvoteUserList = [];
        }
      });
    },
    //根据id查看市场详情
    findByMarkets(market) {
      localStorage.setItem('SIP-marketsCode', market.code);
      localStorage.setItem('SIP-marketsTitle', market.name);
      this.$store.dispatch("marketsDescHandler", market.description);
      this.$router.push({
        name: 'marketPosts',
        params: {
          marketsName: market.name
        }
      });
    },
    //日期格式化
    dateFormat(time) {
      let timeOffset = -28800000;
      if (this.user) {
        timeOffset = this.user.timeOffset;
      }
      return formatDate(time, timeOffset, this.$i18n.locale);
    }
  }
};
</script>



// WEBPACK FOOTER //
// Post.vue?1788cc82